<template>
  <div id="app">
    <Header v-if="showHeader" />
    <el-container class="content">
      <Menu v-if="showHeader" />
      <el-container>
        <el-main>
          <Bread v-if="showBread" />
          <div class="cont">
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import Header from "@/components/common/Header.vue";
  import Menu from "@/components/common/Menu.vue";
  import Bread from "@/components/common/Breadcrumb.vue";
  export default {
    components: { Header, Menu, Bread },
    data() {
      return {
        showHeader: false,
        showBread: false,
      };
    },
    // mounted() {
    //   if (this.$route.path === "/" || this.$route.path === "/login") {
    //     this.showHeader = false;
    //     this.showBread = false;
    //   }
    // },
    // beforeUpdate() {
    //   if (this.$route.path != "/" && this.$route.path != "/login") {
    //     this.showHeader = true;
    //     this.showBread = true;
    //   }else{
    //     this.showHeader = false;
    //     this.showBread = false;
    //   }
    //   if(this.$route.path.length>20){
    //     this.showBread = false;
    //   }
    // },
    watch: {
      $route: {
        immediate: true,
        handler() {
          if (
            this.$route.path !== "/" &&
            // this.$route.path !== "/login"
            !this.$route.path.includes("login")
          ) {
            this.showHeader = true;
            this.showBread = true;
          } else {
            this.showHeader = false;
            this.showBread = false;
          }
          if (
            this.$route.path.length > 20 &&
            !this.$route.path.includes("users")
          ) {
            this.showBread = false;
          }
        },
      },
    },
  };
</script>

<style lang="scss">
  .el-table-filter__list {
    max-height: 400px;
    overflow-y: auto;
  }
  @import url("./assets/css/reset.css");
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    .el-main {
      padding: 15px;
    }
    .content {
      position: absolute;
      width: 100%;
      top: 60px;
      bottom: 0;
      .cont {
        margin: 6px 0;
      }
      .show {
        margin: 10px 0;
      }
    }
  }
</style>
